import moment from 'moment';
import 'moment-timezone';

/* Converting Timestamp and Date */

export function toDate(value) {
    const dateValue = parseInt(value, 10);
    const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
    ];
    const selectedDate = new Date(dateValue);
    const month = selectedDate.getMonth();
    const subYear = selectedDate.getFullYear().toString().substr(-2);

    return `${selectedDate.getDate()} ${monthNames[month]} ${subYear}`;
}

export function toTimestamp(value) {
    let dateValue = value;
    if (value.split(' ').length === 1) {
        dateValue = parseInt(value, 10);
    }
    // make sure the date supplied on local date/time
    const timestampDate = (moment.tz(dateValue, 'Australia/Sydney').unix() * 1000) + (moment(dateValue).utcOffset() * 60000);

    return timestampDate;
}
